import { getEnvRuntimeVariable } from '@if/core/utils'

export const SUPPORTED_DOCUMENT_TYPES = '.jpg, .jpeg, .png, .pdf, .heic, .heif'
export const SYSTEM_USER_ID = 'system'
export const CLEAR_CACHE_EXCEPTION_KEY = ['mui-mode']

export const falsy = () => false

// To disable it just set the env var to an empty string
export const useDevTools = getEnvRuntimeVariable<boolean>(import.meta.env.VITE_USE_DEV_TOOLS)

// Document Type Mappings
export const DocumentTypes = {
  Contract: 'contract',
  Dcc: 'dcc',
  Engagement: 'engagement',
  RepayCapacity: 'repaycapacity',
  Annex: 'annex',
  Paystub: 'paystub',
  ProofIncome: 'proofincome',
  VoidCheck: 'voidcheck',
  BankStatement: 'bankstatement',
  CreditFile: 'creditfile',
  DriverLicence: 'driverlicence',
  IdPhoto: 'idphoto',
  WorkPermit: 'workpermit',
  Carfax: 'carfax',
  Bankruptcy: 'bankruptcy',
  OtherContract: 'othercontract',
  Reference: 'reference',
  WindowSticker: 'windowsticker',
  SignatureAudit: 'signatureaudit',
  Registration: 'registration',
  Other: 'others',
} as const

export type ClassifiedDocumentType = Exclude<
  (typeof DocumentTypes)[keyof typeof DocumentTypes],
  typeof DocumentTypes.BankStatement
>

// FA (ICEBERG FINANCE) Classification to Document Type ID
export const FA_CLASSIFICATION_MAPPING: Record<string, number> = {
  [DocumentTypes.Contract]: 15,
  [DocumentTypes.Dcc]: 16,
  [DocumentTypes.Engagement]: 15,
  [DocumentTypes.RepayCapacity]: 116,
  [DocumentTypes.Annex]: 136,
  [DocumentTypes.Paystub]: 17,
  [DocumentTypes.ProofIncome]: 68,
  [DocumentTypes.VoidCheck]: 19,
  [DocumentTypes.BankStatement]: 30,
  [DocumentTypes.CreditFile]: 45,
  [DocumentTypes.DriverLicence]: 20,
  [DocumentTypes.IdPhoto]: 21,
  [DocumentTypes.WorkPermit]: 107,
  [DocumentTypes.Carfax]: 27,
  [DocumentTypes.Bankruptcy]: 33,
  [DocumentTypes.OtherContract]: 53,
  [DocumentTypes.Other]: 53,
  [DocumentTypes.Reference]: 59,
  [DocumentTypes.WindowSticker]: 22,
  [DocumentTypes.SignatureAudit]: 120,
  [DocumentTypes.Registration]: 41,
}

// IFP Classification to Document Type ID
export const IFP_CLASSIFICATION_MAPPING: Record<string, number> = {
  [DocumentTypes.Dcc]: 4,
  [DocumentTypes.Contract]: 3,
  [DocumentTypes.IdPhoto]: 16,
  [DocumentTypes.VoidCheck]: 8,
  [DocumentTypes.WorkPermit]: 20,
  [DocumentTypes.DriverLicence]: 2,
  [DocumentTypes.BankStatement]: 19,
  [DocumentTypes.RepayCapacity]: 13,
  [DocumentTypes.Annex]: 7,
  [DocumentTypes.Other]: 7,
  [DocumentTypes.Carfax]: 7,
  [DocumentTypes.Paystub]: 7,
  [DocumentTypes.CreditFile]: 7,
  [DocumentTypes.Bankruptcy]: 7,
  [DocumentTypes.Engagement]: 7,
  [DocumentTypes.ProofIncome]: 7,
  [DocumentTypes.OtherContract]: 7,
  [DocumentTypes.Reference]: 7,
  [DocumentTypes.WindowSticker]: 7,
  [DocumentTypes.SignatureAudit]: 18,
  [DocumentTypes.Registration]: 22,
}

// Predefined tags for document categorization
export const PREDEFINED_TAGS = ['credit', 'revenue', 'worksheet', 'payout'] as const

// Predefined reasons for discarding a document. Stored server-side as a free-form
// note, so we use the French label as the canonical value (Iceberg operates in QC).
export const DISCARD_REASON_LABELS_FR = {
  alreadyProcessedInOutlook: 'Déjà traité dans Outlook',
  notForAnApplication: 'Ne va pas dans une demande',
  wrongDocument: 'Mauvais document',
  duplicate: 'Duplicata',
  unreadable: 'Illisible',
  other: 'Autre',
} as const
export const DISCARD_REASONS = Object.keys(DISCARD_REASON_LABELS_FR) as DiscardReasonKey[]
export type DiscardReasonKey = keyof typeof DISCARD_REASON_LABELS_FR
